import React from "react";
import TagActionsMenu from "../../distributor-settings/tags/tags-table/tag-actions-menu.component";
import ColorPickerDropdown from "../../distributor-settings/tags/tags-table/color-picker-dropdown.component";
import styles from "./name-color-row.module.scss";
import cn from "../../../Utils/class-names.utils";
import { NameColorData } from "./name-color-table.component";

interface NameColorRowProps<T extends NameColorData> {
  item: T;
  editingId: number | null;
  editingValue: string;
  inputRef: React.RefObject<HTMLInputElement>;
  onNameClick: (item: T) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onInputKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onInputBlur: () => void;
  onColorSelect: (id: number, color: string) => void;
  onToggleDisable?: (id: number) => void;
  onDelete?: (id: number) => void;
}

function NameColorRow<T extends NameColorData>({
  item,
  editingId,
  editingValue,
  inputRef,
  onNameClick,
  onInputChange,
  onInputKeyDown,
  onInputBlur,
  onColorSelect,
  onToggleDisable,
  onDelete,
}: NameColorRowProps<T>) {
  const handleColorSelect = (color: string) => {
    onColorSelect(item.id, color);
  };

  return (
    <div className={styles.row}>
      <div className={cn(styles.rowCell)}>
        <div className={cn(styles.nameColumn, "text-ellipsis")}>
          {editingId === item.id ? (
            <div className={styles.editingInput}>
              <div className={styles.editingInputContent}>
                <div className={styles.editingInputInner}>
                  <input
                    ref={inputRef}
                    type="text"
                    className={styles.editingInputText}
                    value={editingValue}
                    onChange={onInputChange}
                    onKeyDown={onInputKeyDown}
                    onBlur={onInputBlur}
                  />

                  <div className={styles.dividerContainer}>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={cn(styles.nameDisplay, "text-ellipsis")}>
              <div className={cn(styles.nameWrapper, "text-ellipsis")}>
                <div
                  className={cn(styles.name, "text-ellipsis", {
                    [styles.disabled]: item.isDisabled
                  })}
                  onClick={() => onNameClick(item)}
                  style={{
                    cursor: item.isDisabled ? "default" : "pointer",
                  }}
                >
                  <span className="text-ellipsis">{item.name}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={styles.rowCell}>
        <div className={styles.associatedMSPsColumn}>
          <div className={styles.associatedMSPsCell}>
            <div className={styles.associatedMSPsContent}>
              <div
                className={`${styles.associatedMSPsText} ${
                  item.isDisabled ? styles.disabled : ""
                }`}
              >
                {item.associatedMSPs}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.rowCell}>
        <div className={styles.colorColumn}>
          <ColorPickerDropdown
            color={item.color}
            isDisabled={item.isDisabled}
            onColorSelect={handleColorSelect}
            popperConfig={{ strategy: "fixed" }}
            renderOnMount
          />
        </div>
      </div>

      <div className={styles.rowCell}>
        <div className={styles.actionsColumn}>
          <TagActionsMenu
            isDisabled={item.isDisabled}
            onToggleDisable={() => onToggleDisable?.(item.id)}
            onDelete={() => onDelete?.(item.id)}
          />
        </div>
      </div>
    </div>
  );
}

export default NameColorRow;

